import React, { useState, useEffect, useMemo, useCallback } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import { Modal } from "react-bootstrap";
import {
  FaUsers,
  FaSearch,
  FaCheck,
  FaCheckDouble,
  FaTimes,
  FaUserGraduate,
  FaLayerGroup,
} from "react-icons/fa";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";
import "../css/Admin_css/admin-customize.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const DIALOG_STYLES = `
  .mdl-ess-dialog.modal-dialog {
    z-index: 1050 !important;
    position: relative;
    margin: 0.75rem auto;
    max-width: 900px;
  }
  .mdl-ess-dialog .modal-content {
    z-index: 1051 !important;
    border-radius: 18px;
    overflow: hidden;
    border: none;
    box-shadow: 0 24px 48px rgba(1, 87, 155, 0.22);
    background: #fff;
  }
  .mdl-ess-dialog .modal-header {
    border: none;
    padding: 14px 18px 12px;
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 52%, #01579b 100%);
  }
  .mdl-ess-dialog .modal-header .close {
    color: #fff;
    opacity: 0.9;
    text-shadow: none;
    font-size: 1.55rem;
    font-weight: 400;
    margin: 0 0 0 10px;
    padding: 4px 8px;
    align-self: flex-start;
    line-height: 1;
  }
  .mdl-ess-dialog .modal-header .close:hover {
    opacity: 1;
  }
  .mdl-ess-dialog .modal-body {
    padding: 0;
    background: #f4fafd;
  }
  .mdl-ess-dialog .modal-footer {
    border-top: 1px solid #d7eef9;
    padding: 12px 18px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .ess-title {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 14px;
    margin: 0;
    color: #fff;
    width: 100%;
    flex-wrap: wrap;
  }
  .ess-title__brand {
    display: inline-flex;
    align-items: flex-start;
    gap: 11px;
    flex-shrink: 0;
    max-width: 280px;
  }
  .ess-title__icon {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.2);
    border: 1px solid rgba(255,255,255,0.38);
    font-size: 16px;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.25);
  }
  .ess-title__main {
    font-size: 16px;
    font-weight: 800;
    line-height: 1.2;
    letter-spacing: 0.01em;
  }
  .ess-title__hint {
    font-size: 11.5px;
    font-weight: 500;
    color: rgba(255,255,255,0.9);
    margin-top: 3px;
    line-height: 1.35;
  }
  .ess-title__tools {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 1 260px;
    min-width: 0;
    justify-content: flex-end;
  }
  .ess-body {
    padding: 8px 15px 10px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .ess-panel {
    background: #fff;
    border: 1px solid #dceef8;
    border-radius: 14px;
    padding: 6px 6px 10px;
    box-shadow: 0 2px 8px rgba(2, 136, 209, 0.05);
  }
  .ess-panel__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 10px;
  }
  .ess-section-label {
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #64748b;
    margin: 0;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .ess-section-label svg {
    color: #0288d1;
    font-size: 12px;
  }
  .ess-panel__meta {
    font-size: 11px;
    font-weight: 700;
    color: #0288d1;
    background: #e1f5fe;
    border-radius: 999px;
    padding: 3px 9px;
    white-space: nowrap;
  }
  .ess-class-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-height: 108px;
    overflow-y: auto;
    padding: 1px;
  }
  .ess-class-chips::-webkit-scrollbar,
  .ess-list::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  .ess-class-chips::-webkit-scrollbar-thumb,
  .ess-list::-webkit-scrollbar-thumb {
    background: #b3e5fc;
    border-radius: 999px;
  }
  .ess-chip {
    border: 1.5px solid #cfe8f7;
    background: #f8fcff;
    color: #01579b;
    border-radius: 10px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease, border-color 0.12s ease;
    line-height: 1.2;
    min-width: 108px;
    text-align: center;
  }
  .ess-chip:hover {
    transform: translateY(-1px);
    border-color: #81d4fa;
    background: #fff;
    box-shadow: 0 4px 12px rgba(2, 136, 209, 0.12);
  }
  .ess-chip.is-active {
    background: linear-gradient(135deg, #03a9f4 0%, #0277bd 100%);
    border-color: transparent;
    color: #fff;
    box-shadow: 0 6px 14px rgba(2, 136, 209, 0.3);
  }
  .ess-search {
    flex: 1 1 170px;
    position: relative;
    min-width: 150px;
    max-width: 280px;
  }
  .ess-search__icon {
    position: absolute;
    left: 11px;
    top: 50%;
    transform: translateY(-50%);
    color: rgba(255,255,255,0.78);
    font-size: 12px;
    pointer-events: none;
  }
  .ess-search__input {
    width: 100%;
    height: 36px;
    border-radius: 10px;
    border: 1.5px solid rgba(255,255,255,0.42);
    padding: 0 12px 0 32px;
    font-size: 12.5px;
    background: rgba(255,255,255,0.16);
    color: #fff;
    outline: none;
  }
  .ess-search__input::placeholder {
    color: rgba(255,255,255,0.72);
  }
  .ess-search__input:focus {
    border-color: rgba(255,255,255,0.9);
    background: rgba(255,255,255,0.24);
    box-shadow: 0 0 0 3px rgba(255,255,255,0.14);
  }
  .ess-search__input:disabled {
    opacity: 0.55;
  }
  .ess-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 36px;
    height: 36px;
    padding: 0 10px;
    border-radius: 10px;
    background: rgba(255,255,255,0.2);
    color: #fff;
    font-size: 13px;
    font-weight: 800;
    white-space: nowrap;
    border: 1px solid rgba(255,255,255,0.32);
  }
  .ess-btn {
    height: 36px;
    border-radius: 10px;
    border: none;
    padding: 0 12px;
    font-size: 12px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: transform 0.12s ease, box-shadow 0.12s ease, opacity 0.12s ease, background 0.12s ease;
  }
  .ess-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .ess-btn--ghost {
    background: rgba(255,255,255,0.16);
    border: 1.5px solid rgba(255,255,255,0.42);
    color: #fff;
  }
  .ess-btn--ghost:hover:not(:disabled) {
    background: rgba(255,255,255,0.28);
  }
  .ess-btn--primary {
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
    color: #fff;
    box-shadow: 0 4px 14px rgba(2, 136, 209, 0.3);
    height: 40px;
    padding: 0 18px;
    font-size: 13px;
  }
  .ess-btn--primary:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 8px 18px rgba(2, 136, 209, 0.36);
  }
  .ess-btn--primary.is-disabled {
    background: #94a3b8;
    box-shadow: none;
  }
  .ess-btn--muted {
    background: #f8fafc;
    border: 1.5px solid #e2e8f0;
    color: #64748b;
    height: 40px;
    padding: 0 16px;
  }
  .ess-btn--muted:hover:not(:disabled) {
    background: #f1f5f9;
    color: #334155;
  }
  .ess-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    max-height: min(50vh, 400px);
    overflow-y: auto;
    padding: 2px 4px 4px 2px;
  }
  @media (max-width: 700px) {
    .ess-list {
      grid-template-columns: 1fr;
      max-height: 44vh;
    }
    .ess-title__brand {
      max-width: 100%;
    }
    .ess-title__tools {
      width: 100%;
      justify-content: stretch;
    }
    .ess-search {
      max-width: none;
      flex: 1;
    }
  }
  .ess-card {
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 11px 12px;
    border-radius: 14px;
    border: 1.5px solid #e8eef3;
    background: #fff;
    cursor: pointer;
    transition: border-color 0.14s ease, box-shadow 0.14s ease, background 0.14s ease, transform 0.14s ease;
    text-align: left;
    width: 100%;
  }
  .ess-card:hover {
    border-color: #7dd3fc;
    box-shadow: 0 6px 16px rgba(2, 136, 209, 0.1);
    transform: translateY(-1px);
  }
  .ess-card.is-selected {
    border-color: #03a9f4;
    background: linear-gradient(135deg, #e8f7fe 0%, #ffffff 62%);
    box-shadow: 0 6px 18px rgba(2, 136, 209, 0.14);
  }
  .ess-card__avatar {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    background: linear-gradient(145deg, #e1f5fe, #b3e5fc);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #fff;
    box-shadow: 0 0 0 1.5px #b3e5fc;
    color: #0277bd;
    font-size: 17px;
  }
  .ess-card.is-selected .ess-card__avatar {
    box-shadow: 0 0 0 1.5px #03a9f4;
  }
  .ess-card__avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .ess-card__meta {
    min-width: 0;
    flex: 1;
  }
  .ess-card__name {
    margin: 0;
    font-size: 13.5px;
    font-weight: 750;
    color: #0f172a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ess-card__sub {
    margin: 2px 0 0;
    font-size: 11px;
    color: #64748b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ess-card__badges {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 5px;
  }
  .ess-badge {
    font-size: 10px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 6px;
    background: #f1f5f9;
    color: #475569;
  }
  .ess-badge--accent {
    background: #e1f5fe;
    color: #0277bd;
  }
  .ess-check {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid #cbd5e1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #fff;
    font-size: 11px;
    background: #fff;
    transition: background 0.12s ease, border-color 0.12s ease, transform 0.12s ease;
  }
  .ess-card.is-selected .ess-check {
    background: #03a9f4;
    border-color: #0288d1;
    transform: scale(1.05);
  }
  .ess-empty {
    grid-column: 1 / -1;
    text-align: center;
    padding: 40px 16px;
    color: #64748b;
  }
  .ess-empty__icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    margin: 0 auto 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(145deg, #e1f5fe, #b3e5fc);
    color: #0277bd;
    font-size: 22px;
  }
  .ess-empty__title {
    margin: 0;
    font-size: 14px;
    font-weight: 750;
    color: #334155;
  }
  .ess-empty__hint {
    margin: 5px 0 0;
    font-size: 12px;
    color: #94a3b8;
  }
  .ess-footer-summary {
    font-size: 12px;
    color: #64748b;
    font-weight: 600;
    min-width: 0;
  }
  .ess-footer-summary strong {
    color: #0288d1;
    font-weight: 800;
  }
  .ess-footer-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }
`;

//Created By Cursor
function classLabel(item) {
  if (!item) return "Class";
  if (item.section_id === "No" || !item.section_name) {
    return item.class_name || "Class";
  }
  return `${item.class_name}:${item.section_name}`;
}

//Created By Cursor
function studentMatchesQuery(student, q) {
  if (!q) return true;
  const hay = [
    student.stu_name,
    student.father_name,
    student.student_enrollment_no,
    student.student_roll_no,
    student.class_name,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
  return hay.includes(q);
}

//Created By Cursor
const MdlSelectExamClassAndMultipleStudent = ({
  action,
  action2,
  exam_id,
  session_id,
}) => {
  const [loading, setLoading] = useState(false);
  const [show] = useState(true);
  const [loadingStudent, setLoadingStudent] = useState(false);
  const [participatingClasses, setParticipatingClasses] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [selectedClassIndex, setSelectedClassIndex] = useState(0);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  //Created By Cursor
  const persistSelection = useCallback((list) => {
    setSelectedStudents(list);
    localStorage.setItem("SelectedMultipleStudent", JSON.stringify(list));
  }, []);

  //Created By Cursor
  const fetchStudentList = useCallback(
    (classId, sectionId) => {
      if (!classId) return;
      setLoadingStudent(true);
      setStudentList([]);
      const schoolCode = SessionManager.getSchoolCode();
      axios
        .get(`${API_BASE()}getCurrentStudent.php`, {
          params: {
            school_code: schoolCode,
            class_id: classId,
            section_id: sectionId,
            session_id,
            _ts: Date.now(),
          },
          headers: { "Cache-Control": "no-cache" },
        })
        .then((response) => {
          const data = response.data;
          setLoadingStudent(false);
          if (data.api_status === "OK") {
            setStudentList(Array.isArray(data.data) ? data.data : []);
          } else {
            setStudentList([]);
            myToast.notify_warning(data.api_remark || "Could not load students.");
          }
        })
        .catch((error) => {
          setLoadingStudent(false);
          setStudentList([]);
          console.error("Error fetching students:", error);
          myToast.notify_warning("Network error loading students.");
        });
    },
    [session_id]
  );

  //Created By Cursor
  const selectClass = useCallback(
    (position, classes = participatingClasses) => {
      persistSelection([]);
      setSearchTerm("");
      const selectedClass = classes[position];
      if (!selectedClass) return;
      setSelectedClassIndex(position);
      fetchStudentList(
        selectedClass.class_id,
        selectedClass.section_id || "No"
      );
    },
    [participatingClasses, fetchStudentList, persistSelection]
  );

  //Created By Cursor
  const fetchParticipatingClasses = useCallback(() => {
    setLoading(true);
    const schoolCode = SessionManager.getSchoolCode();
    axios
      .get(`${API_BASE()}getExamParticipatingClass.php`, {
        params: {
          school_code: schoolCode,
          session_id,
          exam_id,
          _ts: Date.now(),
        },
        headers: { "Cache-Control": "no-cache" },
      })
      .then((response) => {
        const data = response.data;
        setLoading(false);
        if (data.api_status === "OK") {
          const classes = Array.isArray(data.data) ? data.data : [];
          setParticipatingClasses(classes);
          if (classes.length > 0) {
            persistSelection([]);
            setSelectedClassIndex(0);
            setSearchTerm("");
            fetchStudentList(
              classes[0].class_id,
              classes[0].section_id || "No"
            );
          }
        } else {
          setParticipatingClasses([]);
          myToast.notify_warning(data.api_remark || "No participating classes.");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching classes:", error);
        myToast.notify_warning("Network error loading classes.");
      });
  }, [exam_id, session_id, fetchStudentList, persistSelection]);

  useEffect(() => {
    localStorage.setItem("SelectedMultipleStudent", JSON.stringify([]));
    fetchParticipatingClasses();
  }, [fetchParticipatingClasses]);

  const visibleStudents = useMemo(() => {
    const q = searchTerm.trim().toLowerCase();
    return studentList.filter((s) => studentMatchesQuery(s, q));
  }, [studentList, searchTerm]);

  const allVisibleSelected =
    visibleStudents.length > 0 &&
    visibleStudents.every((s) =>
      selectedStudents.some(
        (sel) => sel.student_enrollment_no === s.student_enrollment_no
      )
    );

  //Created By Cursor
  const toggleStudent = (student) => {
    const exists = selectedStudents.some(
      (s) => s.student_enrollment_no === student.student_enrollment_no
    );
    if (exists) {
      persistSelection(
        selectedStudents.filter(
          (s) => s.student_enrollment_no !== student.student_enrollment_no
        )
      );
    } else {
      persistSelection([...selectedStudents, student]);
    }
  };

  //Created By Cursor
  const handleSelectAllVisible = () => {
    if (allVisibleSelected) {
      const visibleIds = new Set(
        visibleStudents.map((s) => s.student_enrollment_no)
      );
      persistSelection(
        selectedStudents.filter((s) => !visibleIds.has(s.student_enrollment_no))
      );
      return;
    }
    const map = new Map(
      selectedStudents.map((s) => [s.student_enrollment_no, s])
    );
    visibleStudents.forEach((s) => map.set(s.student_enrollment_no, s));
    persistSelection(Array.from(map.values()));
  };

  //Created By Cursor
  const handleDone = () => {
    if (!selectedStudents.length) {
      myToast.notify_warning("Please select at least one student.");
      return;
    }
    if (typeof action2 === "function") action2();
  };

  const activeClass = participatingClasses[selectedClassIndex];
  const canDone = selectedStudents.length > 0;

  return (
    <>
      <style>{DIALOG_STYLES}</style>
      <Modal
        show={show}
        onHide={action}
        animation={false}
        centered
        size="lg"
        dialogClassName="mdl-ess-dialog"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <div className="ess-title">
            <div className="ess-title__brand">
              <span className="ess-title__icon" aria-hidden>
                <FaUsers />
              </span>
              <div>
                <div className="ess-title__main">Select Students</div>
                <div className="ess-title__hint">
                  Select a participating class, then pick students.
                </div>
              </div>
            </div>
            <div className="ess-title__tools">
              <div className="ess-search">
                <FaSearch className="ess-search__icon" aria-hidden />
                <input
                  type="search"
                  className="ess-search__input"
                  placeholder="Search name or roll…"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  aria-label="Search students"
                  disabled={loading || loadingStudent || studentList.length === 0}
                />
              </div>
              <div className="ess-count" title="Selected students">
                {selectedStudents.length}
              </div>
              <button
                type="button"
                className="ess-btn ess-btn--ghost"
                onClick={handleSelectAllVisible}
                disabled={loading || loadingStudent || visibleStudents.length === 0}
              >
                {allVisibleSelected ? (
                  <>
                    <FaTimes aria-hidden /> Deselect
                  </>
                ) : (
                  <>
                    <FaCheckDouble aria-hidden /> Select all
                  </>
                )}
              </button>
              <button
                type="button"
                className={`ess-btn ess-btn--primary${!canDone ? " is-disabled" : ""}`}
                onClick={handleDone}
                disabled={!canDone}
                title="Done"
                style={
                  canDone
                    ? {
                        background: `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 100%)`,
                      }
                    : undefined
                }
              >
                <FaCheck aria-hidden /> Done
              </button>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          {loading ? (
            <div style={{ padding: 36 }}>
              <MyLoader />
            </div>
          ) : (
            <div className="ess-body">
              <div className="ess-panel">
                <div className="ess-panel__head">
                  <p className="ess-section-label">
                    <FaLayerGroup aria-hidden /> Participating class
                  </p>
                  {participatingClasses.length > 0 ? (
                    <span className="ess-panel__meta">
                      {participatingClasses.length} class
                      {participatingClasses.length !== 1 ? "es" : ""}
                    </span>
                  ) : null}
                </div>
                {participatingClasses.length === 0 ? (
                  <div className="ess-empty" style={{ padding: "18px 12px" }}>
                    <div className="ess-empty__icon" aria-hidden>
                      <FaUserGraduate />
                    </div>
                    <p className="ess-empty__title">No participating classes</p>
                    <p className="ess-empty__hint">
                      Add classes to this exam, then try again.
                    </p>
                  </div>
                ) : (
                  <div
                    className="ess-class-chips"
                    role="listbox"
                    aria-label="Classes"
                  >
                    {participatingClasses.map((item, index) => (
                      <button
                        key={`${item.class_id}-${item.section_id}-${index}`}
                        type="button"
                        role="option"
                        aria-selected={selectedClassIndex === index}
                        className={`ess-chip${
                          selectedClassIndex === index ? " is-active" : ""
                        }`}
                        onClick={() => selectClass(index)}
                      >
                        {classLabel(item)}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <div className="ess-panel" style={{ paddingBottom: 8 }}>
                <div className="ess-panel__head">
                  <p className="ess-section-label">
                    <FaUserGraduate aria-hidden /> Students
                  </p>
                  <span className="ess-panel__meta">
                    {loadingStudent
                      ? "Loading…"
                      : `${visibleStudents.length} shown · ${selectedStudents.length} selected`}
                  </span>
                </div>

                {loadingStudent ? (
                  <div style={{ padding: 28 }}>
                    <MyLoader />
                  </div>
                ) : (
                  <div className="ess-list" role="list">
                    {visibleStudents.length === 0 ? (
                      <div className="ess-empty">
                        <div className="ess-empty__icon" aria-hidden>
                          <FaUserGraduate />
                        </div>
                        <p className="ess-empty__title">
                          {studentList.length === 0
                            ? activeClass
                              ? `No students in ${classLabel(activeClass)}`
                              : "No students found"
                            : "No matches for your search"}
                        </p>
                        <p className="ess-empty__hint">
                          {studentList.length === 0
                            ? "Try another class."
                            : "Clear the search or try a different name."}
                        </p>
                      </div>
                    ) : (
                      visibleStudents.map((student) => {
                        const selected = selectedStudents.some(
                          (s) =>
                            s.student_enrollment_no ===
                            student.student_enrollment_no
                        );
                        const img = student.student_img_path;
                        return (
                          <button
                            key={
                              student.student_enrollment_no || student.stu_name
                            }
                            type="button"
                            role="listitem"
                            className={`ess-card${
                              selected ? " is-selected" : ""
                            }`}
                            onClick={() => toggleStudent(student)}
                            aria-pressed={selected}
                          >
                            <div className="ess-card__avatar" aria-hidden>
                              {img ? (
                                <img
                                  src={img}
                                  alt=""
                                  onError={(e) => {
                                    e.currentTarget.style.display = "none";
                                  }}
                                />
                              ) : (
                                <FaUserGraduate />
                              )}
                            </div>
                            <div className="ess-card__meta">
                              <p className="ess-card__name">
                                {student.stu_name || "Untitled"}
                              </p>
                              <p className="ess-card__sub">
                                Father: {student.father_name || "—"}
                              </p>
                              <div className="ess-card__badges">
                                <span className="ess-badge ess-badge--accent">
                                  Roll {student.student_roll_no || "—"}
                                </span>
                                <span className="ess-badge">
                                  {student.student_enrollment_no || "—"}
                                </span>
                              </div>
                            </div>
                            <span className="ess-check" aria-hidden>
                              {selected ? <FaCheck /> : null}
                            </span>
                          </button>
                        );
                      })
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <div className="ess-footer-summary">
            {activeClass ? (
              <>
                Class <strong>{classLabel(activeClass)}</strong>
                {" · "}
                <strong>{selectedStudents.length}</strong> selected
              </>
            ) : (
              <>
                <strong>{selectedStudents.length}</strong> selected
              </>
            )}
          </div>
          <div className="ess-footer-actions">
            <button
              type="button"
              className="ess-btn ess-btn--muted"
              onClick={action}
            >
              Cancel
            </button>
            <button
              type="button"
              className={`ess-btn ess-btn--primary${!canDone ? " is-disabled" : ""}`}
              onClick={handleDone}
              disabled={!canDone}
              style={
                canDone
                  ? {
                      background: `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 100%)`,
                    }
                  : undefined
              }
            >
              <FaCheck aria-hidden /> Done ({selectedStudents.length})
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MdlSelectExamClassAndMultipleStudent;
